export function ReasonSection() {
  const reasons = [
    {
      number: '01',
      title: '学校別対策',
      description: '各中学校のテスト範囲・出題傾向を分析。学校のワークを使った対策で、確実に点数を上げます。',
      icon: 'ri-school-line'
    },
    {
      number: '02',
      title: 'ワーク管理',
      description: '学校のワークの進捗を毎回チェック。提出物の遅れをなくし、内申点アップにつなげます。',
      icon: 'ri-file-list-line'
    },
    {
      number: '03',
      title: 'テスト範囲分析',
      description: 'テスト2週間前から範囲を徹底分析。出やすい問題を予測し、効率的に学習します。',
      icon: 'ri-search-eye-line'
    },
    {
      number: '04',
      title: '反復演習',
      description: '同じ問題を3回以上繰り返し演習。「わかる」から「できる」に変えて、確実に得点力を上げます。',
      icon: 'ri-repeat-line'
    }
  ];

  return (
    <section className="py-16 px-4 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-black text-gray-800 mb-4">
            定期テストで<br className="md:hidden" />点数が上がる仕組み
          </h2>
          <p className="text-sm md:text-base text-gray-600">
            廿日市市の定期テスト対策で、確実に成績アップ
          </p>
        </div>

        <div className="space-y-6">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all p-6 md:p-8 border-l-4 border-blue-600"
            >
              <div className="flex flex-col md:flex-row items-start gap-4">
                <div className="flex items-center gap-4 md:gap-6 w-full md:w-auto">
                  <div className="text-5xl md:text-6xl font-black text-blue-100">
                    {reason.number}
                  </div>
                  <div className="w-14 h-14 flex items-center justify-center bg-blue-100 rounded-xl flex-shrink-0">
                    <i className={`${reason.icon} text-3xl text-blue-600`}></i>
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-3">
                    {reason.title}
                  </h3>
                  <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                    {reason.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-orange-50 border-2 border-orange-200 rounded-2xl p-6 md:p-8">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-full flex-shrink-0">
              <i className="ri-lightbulb-flash-line text-2xl text-white"></i>
            </div>
            <div>
              <h4 className="text-lg md:text-xl font-bold text-gray-800 mb-2">
                勉強のやり方から教えます
              </h4>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                中学生の塾では、ただ問題を解くだけでなく、<strong>勉強のやり方</strong>から丁寧に指導。ノートの取り方、復習の仕方、暗記のコツなど、一生使える学習スキルが身につきます。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
